// 检测埋点是否加载
// vnode-节点  eventName事件名称
function waitMatomoInit(vnode, that) {
  const self = vnode.context || that;

  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (self.$matomo) {
        clearInterval(interval);
        resolve();
      }
    }, 50);
  });
}

// 发送埋点数据
// vnode-节点  eventName事件名称
async function trackEvent(vnode, eventCode, value) {
  await waitMatomoInit(vnode);
  const self = vnode.context;
  self.$matomo.trackEvent('jfsc', eventCode, 'jfsc', 'jfsc', value);
  // gio('track', eventCode, value);
}

/**
 * @description 主动调用埋点
 * @param {*} self 调用页面的this
 * @param {*} eventCode 时间名称
 * @param {*} value 自定义的值
 */
export async function trackEventActive(self, eventCode, value) {
  await waitMatomoInit('', self);

  self.$matomo.trackEvent('jfsc', eventCode, 'jfsc', 'jfsc', value);
  // gio('track', eventCode, value);
}



